export default __webpack_public_path__ + "static/img3-ac24d13969d4e712c4d0d9d9532fe8cc.png";